<template>
    <div class="page egiftList">
        <div class="container">
            <div class="h1">Your selected cards and recipients</div>
            <div class="descktopMediaBox tableHead">
                <div class="gift">
                    Gift
                </div>
                <div class="recipient">
                    Recipient
                </div>
                <div class="date">
                    Delivery Date
                </div>
                <div class="amount">
                    Amount
                </div>
                <div class="option">
                    Options
                </div>
            </div>
            <div class="glist" v-if="giftCardData.cards.length">
                <div class="gcard" v-for="(gcard,index) in giftCardData.cards">
                    <div class="frame">
                        <img :src="gcard.imgDef" alt="">
                    </div>
                    <div class="recipinet">
                        <div class="title h2">
                            Recipient
                        </div>
                        {{ gcard.recipient_email }}
                    </div>
                    <div class="deliveryDate">
                        <div class="title h2">
                            Delivery Date
                        </div>
                        {{ gcard.delivery_date_object.format("MMMM Do, YYYY") }}
                    </div>
                    <div class="amm">
                        <div class="title h2">
                            Amount
                        </div>
                        ${{ gcard.amount }}
                    </div>
                    <div class="options">
                        <div class="title h2">
                            Options
                        </div>
                        <div class="btns">
                            <a class="smlBtn inv" @click="$router.push({name: 'E-gifts', params: {id: gcard.type_id}, query: {cartItem: index}})">
                                Edit
                            </a>
                            <a class="smlBtn" @click="removeCard(index)">
                                Remove
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flexWrapDesk">
                <div class="subtotal">
                    <div class="title h2">
                        Subtotal: ${{ giftCardData.subTotal() }}
                    </div>
                </div>
                <div class="mainOptions">
                    <a class="smlBtn inv" @click.prevent="$router.push({name: 'E-gifts'})">
                        add Card
                    </a>
                    <a class="smlBtn crims" @click.prevent="$router.push({name: 'EgiftPayment'})">
                        next
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GiftcardsList",
        created() {
            this.$store.commit("shared/setTopBar", {title: "Send an E-Gift", showBackButton: true, showBag: false}, {root: true});
            if (!this.giftCardData.cards.length) {
                this.$router.push({name: 'E-gifts'})
                return false;
            }
        },
        computed: {
            giftCardData() {
                return this.$store.state.giftcard.giftCardData;
            }
        },
        methods: {
            removeCard(index) {
                this.$store.commit("giftcard/removeGiftCard", index);
                if (!this.giftCardData.cards.length) {
                    this.$router.push({name: "E-gifts"});
                }
            }
        }
    }
</script>
